<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-toolbar absolute light floating color="white" class="searchbar">
            <v-layout align-end>
                <v-flex grow>
                    <v-text-field hide-details
                                  prepend-icon="search"
                                  single-line
                                  v-model="query"
                                  @keyup="doSearch(query)"
                                  placeholder="Zoek locatie.."
                    ></v-text-field>
                </v-flex>
                <v-flex shrink>
                    <v-btn icon small v-if="isLocationAvailable"
                           @click="getUserLocation">
                        <v-icon>my_location</v-icon>
                    </v-btn>
                </v-flex>
            </v-layout>

            <v-menu full-width light :position-x="30" :position-y="145" :value="results.length">
                <v-list>
                    <template v-for="(result,i) in results">
                        <v-list-tile v-if="result.type === 'location'"
                                     @click="highlightLocation(result.location)"
                                     :key="i"
                        >
                            <v-list-tile-avatar>
                                <img v-if="result.location.icon" :src="result.location.icon" />
                                <img v-else-if="result.location.image" :src="result.location.image" />
                                <v-icon v-else>
                                    house
                                </v-icon>

                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>{{result.location.name}}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="result.type === 'position'"
                                     @click="showOnMap(result.latLng)"
                                     :key="i"
                        >
                            <v-list-tile-avatar>
                                <v-icon>flag</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                                <v-list-tile-title>{{result.name}}</v-list-tile-title>
                            </v-list-tile-content>

                        </v-list-tile>
                    </template>
                </v-list>
            </v-menu>
        </v-toolbar>

        <div class="highlight-container">
            <v-card v-if="highlightedLocation" light>
                <v-img v-if="highlightedLocation.image"
                       class="white--text"
                       :src="highlightedLocation.image"
                >
                    <v-container fill-height fluid>
                        <v-layout fill-height>
                            <v-flex xs12 align-end flexbox>
                                <span class="headline">{{highlightedLocation.name}}</span>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-img>
                <v-card-title>
                    <div>
                        <strong>{{highlightedLocation.name}}</strong>
                        <br>
                        <span>{{highlightedLocation.slogan}}</span>
                        <br>
                        <span class="grey--text">{{highlightedLocation.address}}</span>
                        <br>
                    </div>
                </v-card-title>
            </v-card>
            <v-card v-if="highlightedPlaygroundEquipment" light>
                <v-card-title>
                    <div>
                        <strong>Speeltoestel {{highlightedPlaygroundEquipment.locatie}}</strong>
                        <br>
                        <span class="grey--text" v-if="highlightedPlaygroundEquipment.leverancie">
                            Geleverd door {{highlightedPlaygroundEquipment.leverancie}}
                        </span>
                        <br>
                    </div>
                </v-card-title>
            </v-card>
            <v-card v-else-if="highlightedArea" light>
                <v-card-title>
                    <div>
                        <strong>{{highlightedArea.wijknaam}}</strong>
                        <br>
                        <span>{{highlightedArea.equipmentCount}} speeltoestellen</span>
                        <br>
                    </div>
                </v-card-title>
            </v-card>
            <v-card v-else-if="selection.length" light absolute left>
                <v-list two-line>
                    <v-list-tile @click="previousSelection" v-if="notFirstInSelection">
                        <v-list-tile-avatar class="text-xs-center">
                            <v-icon>arrow_drop_up</v-icon>
                        </v-list-tile-avatar>
                    </v-list-tile>
                    <template v-for="(item,i) in visibileSelection">
                        <v-list-tile
                            v-if="item.type === 'location'"
                            @click="highlightLocation(item.properties)"
                            :key="i"
                            avatar
                        >
                            <v-list-tile-avatar>
                                <img v-if="item.properties.icon" :src="item.properties.icon" />
                                <img v-else-if="item.properties.image" :src="item.properties.image" />
                                <v-icon v-else>
                                    house
                                </v-icon>

                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title>{{item.properties.name}}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile
                            v-if="item.type === 'area'"
                            @click="highlightArea(item)"
                            :key="i"
                            avatar
                        >
                            <v-list-tile-avatar>
                                <v-icon>flag</v-icon>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title>{{item.properties.wijknaam}}</v-list-tile-title>
                                <v-list-tile-sub-title>
                                    {{item.properties.stadsdeelnaam}})
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                    <v-list-tile @click="nextSelection" v-if="notLastInSelection">
                        <v-list-tile-avatar class="text-xs-center">
                            <v-icon>arrow_drop_down</v-icon>
                        </v-list-tile-avatar>
                    </v-list-tile>
                </v-list>
            </v-card>
        </div>

        <v-btn absolute dark fab bottom right color="accent"
               v-if="hasSelection"
               @click="clearSelection">
            <v-icon>clear</v-icon>
        </v-btn>
        <v-btn absolute dark fab bottom right color="accent"
               v-else-if="selectionMode === 'single'"
               @click="setSelectionMode('box')">
            <v-icon>crop_free</v-icon>
        </v-btn>

        <v-btn absolute dark fab bottom right color="accent"
               v-else-if="selectionMode === 'box'"
               @click="setSelectionMode('single')">
            <v-icon>clear</v-icon>
        </v-btn>

        <div :id="mapId" aria-hidden="true" tabIndex="-1" class="map"></div>
    </div>
</template>

<script>
import axios from 'axios'
import L from 'leaflet'
import 'leaflet-draw'
import _ from 'lodash'
import 'proj4leaflet'
import proj4 from 'proj4'
import faker from 'faker'
import locations from './Maps/locations.json'
import areas from './Maps/areas.json'
import playgroundEquipment from './Maps/speeltoestellen.json'
import turf from 'turf'

export default {
    data () {
        return {
            query: '',
            markerIcon: 'v-icon material-icons theme--light accent--text',
            map: null,
            tileLayer: null,
            areasLayer: null,
            playgroundEquipmentLayer: null,
            locations: [],
            selection: [],
            selectionIndex: 0,
            selectionMode: 'single',
            selectionGroupSize: 3,
            highlightedLocation: null,
            highlightedArea: null,
            highlightedPlaygroundEquipment: null,
            latLng: new L.LatLng(51.4500222, 5.45887073),
            results: [],
            drawMode: null,
            editMode: null,
        }
    },
    computed: {
        mapId () {
            return 'map' + this._uid
        },
        center () {
            return {}
        },
        isLocationAvailable () {
            return !!navigator.geolocation
        },
        notFirstInSelection () {
            return this.selectionIndex !== 0
        },
        notLastInSelection () {
            return this.selectionIndex + this.selectionGroupSize < this.selection.length
        },
        visibileSelection () {
            return this.selection.slice(this.selectionIndex, this.selectionIndex + this.selectionGroupSize)
        },
        hasSelection () {
            return this.selection.length > 0 ||
                this.highlightedLocation ||
                this.highlightedArea ||
                this.highlightedPlaygroundEquipment
        },
    },
    methods: {
        setupLayers () {
            this.tileLayer = new L.TileLayer('https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0/grijs/EPSG:28992/{z}/{x}/{y}.png', {
                WMTS: false,
                minZoom: 7,
                maxZoom: 13,
                attribution: '<a href="http://www.kadaster.nl">Kadaster</a>',
                continuousWorld: true,
            })

            this.areasLayer = new L.GeoJSON(areas, {
                style: {
                    weight: 4,
                    fillOpacity: 0.2,
                    color: this.$store.getters.backgroundColor,
                },
                onEachFeature: (feature, layer) => {
                    layer.on({
                        click: () => {
                            if (this.selectionMode === 'single') {
                                this.highlightArea({ layer })
                            }
                        },
                    })
                },
            })

            this.playgroundEquipmentLayer = new L.GeoJSON(playgroundEquipment, {
                pointToLayer: (feature, latLng) => {
                    let marker = L.circleMarker(latLng, {
                        radius: 8,
                        fillColor: this.$store.getters.backgroundColor,
                        color: this.$store.getters.backgroundColor,
                        weight: 1,
                        opacity: 1,
                        fillOpacity: 0.8,
                    })

                    marker.on('click', () => {
                        if (this.selectionMode === 'single') {
                            console.log('hit')
                            this.highlightEquipment({ marker, ...feature.properties })
                        }
                    })
                    return marker
                },

            })

            L.drawLocal.draw.handlers.rectangle.tooltip = {
                start: 'Klik en sleep een selectie van gebieden en locaties op de kaart',
            }
            L.drawLocal.draw.handlers.simpleshape.tooltip = {
                end: 'Laat los of klik opnieuw om uw selectie af te ronden',
            }
        },
        setupMap () {
            proj4.defs('urn:ogc:def:crs:EPSG::28992', '+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +units=m +towgs84=565.2369,50.0087,465.658,-0.406857330322398,0.350732676542563,-1.8703473836068,4.0812 +_defs')
            const RD = new L.Proj.CRS('EPSG:28992', '+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +units=m +towgs84=565.2369,50.0087,465.658,-0.406857330322398,0.350732676542563,-1.8703473836068,4.0812 +no_defs',
                {
                    resolutions: [3440.640, 1720.320, 860.160, 430.080, 215.040, 107.520, 53.760, 26.880, 13.440, 6.720, 3.360, 1.680, 0.840, 0.420],
                    bounds: L.bounds([-285401.92, 22598.08], [595401.9199999999, 903401.9199999999]),
                    origin: [-285401.92, 22598.08],
                },
            )

            this.map = new L.Map(this.mapId, {
                crs: RD,
                continuousWorld: true,
                zoom: 8,
                keyboard: false,
                zoomControl: true,
                center: this.latLng,
            })

            this.drawMode = new L.Draw.Rectangle(this.map, {
                shapeOptions: {
                    color: this.$store.getters.accentColor,
                    fill: false,
                },
            })

            this.map.zoomControl.setPosition('bottomleft')
            this.addLocations()
            this.map.addLayer(this.tileLayer)
            this.map.addLayer(this.areasLayer)

            this.map.on(L.Draw.Event.CREATED, ({ layer }) => this.drawBoxSelection(layer))
            this.map.on('zoomend', () => {
                if (this.map.getZoom() < 10) {
                    this.map.removeLayer(this.playgroundEquipmentLayer)
                } else {
                    this.map.addLayer(this.playgroundEquipmentLayer)
                    this.playgroundEquipmentLayer.bringToFront()
                }
            })
        },
        async addLocations () {
            return Promise.all(locations.map((record, index) => {
                return new Promise(resolve => {
                    let location = {
                        ...record,
                        index,
                        latLng: new L.LatLng(
                            record.coordinates.lat,
                            record.coordinates.lng,
                        ),
                    }

                    location.marker = L.marker(location.latLng, {
                        icon: L.divIcon({
                            html: `<i class="${this.markerIcon} marker-enter">place</i>`,
                        }),
                    }).on('click', () => {
                        if (this.selectionMode === 'single') {
                            this.highlightLocation(location)
                        }
                    }).addTo(this.map)

                    setTimeout(() => {
                        this.$el.querySelector('.marker-enter').setAttribute('class', this.markerIcon)
                        resolve()
                    })
                    this.locations.push(location)
                })
            }))
        },
        getUserLocation () {
            navigator.geolocation.getCurrentPosition((position) => {
                this.latLng = new L.LatLng(position.coords.latitude, position.coords.longitude)
                this.showOnMap(this.latLng, 10)
            })
        },
        doSearch: _.debounce(function (query) {
            if (query && this.query === query) {
                query = query.toLowerCase()
                this.results = []
                axios.get('https://geodata.nationaalgeoregister.nl/locatieserver/v3/suggest', {
                    params: {
                        fl: 'centroide_ll,weergavenaam,gemeentenaam',
                        q: query,
                    },
                }).then(({ data }) => {
                    this.locations.forEach(location => {
                        if (location.name.toLowerCase().indexOf(query) !== -1) {
                            this.results.push({
                                type: 'location',
                                location,
                            })
                        }
                    })
                    data.response.docs.forEach((doc) => {
                        let coords = doc.centroide_ll.replace('POINT(', '').replace(')', '').split(' ')
                        let latLng = new L.LatLng(coords[1], coords[0])

                        this.results.push({
                            type: 'position',
                            name: doc.weergavenaam,
                            latLng,
                        })
                    })
                })
            }
        }, 200),
        showOnMap (latLng, zoom = false) {
            if (zoom) {
                this.map.setView(latLng, zoom)
            } else {
                this.map.panTo(latLng)
            }

            this.removeMenu()
        },
        setSelectionMode (mode) {
            if (mode === 'single') this.disableBoxSelection()
            else if (mode === 'box') this.enableBoxSelection()

            this.selectionMode = mode
        },
        enableBoxSelection () {
            this.drawMode.enable()
        },
        disableBoxSelection () {
            this.drawMode.disable()
        },
        drawBoxSelection (layer) {
            this.clearBoxSelection()

            let selectionBox = layer.toGeoJSON()

            this.locations.forEach(location => {
                if (turf.inside(turf.point([location.coordinates.lng, location.coordinates.lat]), selectionBox)) {
                    this.selection.push({
                        type: 'location',
                        properties: location,
                        icon: location.marker._icon,
                    })
                    location.marker._icon.setAttribute('selected', true)
                }
            })

            this.areasLayer.getLayers().forEach(area => {
                if (turf.intersect(area.toGeoJSON(), selectionBox)) {
                    this.selection.push({
                        type: 'area',
                        properties: area.feature.properties,
                        layer: area,
                        path: area._path,
                    })
                    area._path.setAttribute('selected', true)
                }
            })

            this.setSelectionMode('single')
        },
        clearBoxSelection () {
            this.selectionIndex = 0
            this.selection.forEach(item => {
                switch (item.type) {
                case 'area':
                    item.path.setAttribute('selected', false)
                    break
                case 'location':
                    item.icon.setAttribute('selected', false)
                    break
                }
            })
            this.selection = []
        },
        highlightArea (area) {
            this.clearSelection()

            this.map.fitBounds(area.layer.getBounds())
            if (!area.equipmentCount) {
                area.equipmentCount = 0
                this.playgroundEquipmentLayer.eachLayer(layer => {
                    let coordinates = layer.getLatLng()
                    if (turf.inside(turf.point([coordinates.lng, coordinates.lat]), area.layer.feature)) {
                        area.equipmentCount++
                    }
                })
            }
            this.highlightedArea = {
                ...area.layer.feature.properties,
                equipmentCount: area.equipmentCount,
            }
        },
        removeAreaHighlight () {
            this.highlightedArea = null
        },
        highlightEquipment (feature) {
            this.clearSelection()

            this.highlightedPlaygroundEquipment = feature
            feature.marker._path.setAttribute('active', true)
        },
        removeEquipmentHighlight () {
            if (this.highlightedPlaygroundEquipment) {
                this.highlightedPlaygroundEquipment.marker._path.setAttribute('active', false)
            }
            this.highlightedPlaygroundEquipment = null
        },
        highlightLocation (location) {
            this.clearSelection()

            location.marker._icon.setAttribute('active', true)
            this.map.setView(location.latLng, 10)
            this.highlightedLocation = location
        },
        removeLocationHighlight () {
            if (this.highlightedLocation) {
                this.highlightedLocation.marker._icon.setAttribute('active', false)
            }
            this.highlightedLocation = null
        },
        previousSelection () {
            this.selectionIndex -= this.selectionGroupSize
        },
        nextSelection () {
            this.selectionIndex += this.selectionGroupSize
        },
        clearSelection () {
            this.removeLocationHighlight()
            this.removeAreaHighlight()
            this.removeEquipmentHighlight()
            this.clearBoxSelection()
            if (this.selectionMode === 'box') this.enableBoxSelection()
        },
        removeMenu () {
            this.query = ''
            this.results = []
        },
        adjustGroupSize () {
            if (window.innerHeight > 950) this.selectionGroupSize = 3
            else if (window.innerHeight > 720) this.selectionGroupSize = 2
            else this.selectionGroupSize = 1
        },
    },
    mounted () {
        faker.locale = 'nl'
        this.setupLayers()
        this.setupMap()
        this.adjustGroupSize()
        window.onresize = this.adjustGroupSize
    },
}
</script>

<style lang="scss">
    @import '../assets/sass/base';

    .map {
        .leaflet-div-icon {
            background: none;
            border: none;

            i {
                font-size: 30px;
                transition: transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                transform-origin: bottom center;

                &.marker-enter {
                    transform: translateY(-100px) scaleY(3);
                }

                &:hover {
                    animation: wiggle .8s infinite linear;
                }
            }
        }

        [active="true"] {
            fill: var(--v-accent-base);
            stroke: var(--v-accent-base);

            > i {
                &,
                &:hover {
                    animation: hop 1s infinite linear;
                }
            }
        }

        [selected="true"] {
            stroke: var(--v-accent-base);
            stroke-width: 4px;
            fill: var(--v-accent-base);
            fill-opacity: 0.5;

            > i {
                &,
                &:hover {
                    color: var(--v-primary-base) !important;
                }
            }
        }
    }

    .searchbar {
        top: 16px;
    }

    @media screen and (max-width: $medium-screen) {
        .searchbar {
            margin: 0;
            left: 0;
            right: 0;
            top: 0;
            z-index: 1;

            .v-toolbar__content {
                width: 100%;
            }
        }
    }

    @keyframes wiggle {
        0% {
            transform: scale(1.2) rotate(-5deg);
        }
        50% {
            transform: scale(1.2) rotate(5deg);
        }
        100% {
            transform: scale(1.2) rotate(-5deg);
        }
    }

    @keyframes hop {
        0% {
            transform: scale(1, 1) translateY(0);
        }
        10% {
            transform: scale(1.1, .9) translateY(0);
        }
        30% {
            transform: scale(.9, 1.1) translateY(-8px);
        }
        50% {
            transform: scale(1, .9) translateY(0);
        }
        60% {
            transform: scale(1, 1) translateY(0);
        }
        100% {
            transform: scale(1, 1) translateY(0);
        }
    }

</style>
<style scoped lang="scss">
    @import '../../node_modules/leaflet/dist/leaflet.css';
    @import '../../node_modules/leaflet-draw/dist/leaflet.draw-src.css';
    @import '../assets/sass/base';

    .map {
        position: fixed;
        top: 57px;
        left: 0;
        right: 0;
        bottom: 0;
    }

    .highlight-container {
        .v-card {
            position: absolute;
            z-index: 10;
            bottom: 10px;
            width: 400px;
            left: calc(50% - 200px);

            .v-image {
                height: 200px;
                width: 400px;
            }
        }
    }

    .v-btn--floating {
        z-index: 12;
        bottom: 45px;
    }

    @media screen and (max-width: $medium-screen) {
        .highlight-container {
            .v-card {
                width: auto;
                bottom: 0;
                left: 0;
                right: 0;

                .v-image {
                    width: 100%;
                    height: 150px;
                }
            }
        }
    }
</style>
